import { useState, useRef, useEffect } from 'react'
import { createModel } from 'hox'
import { useMap } from 'ahooks';
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { settleService } from '../../settleService'
import { BillTotalResult } from '../../settleTypes'
import { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'
import { getBaseImgLookUrl } from '@/utils/constants'

export const totalModel = createModel(function () {

    //列表数据源
    const [dataSource, setDataSource] = useState<BillTotalResult[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<any>({})
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表单数据
    const [formInfo, setFormInfo] = useState<any>({});
    const [uploadFileList, setUploadFileList] = useState<any>([]);
    const [loading, setLoading] = useState(false)
    //弹窗可见
    const [mode, setMode] = useState<string>("update") //update、look
    const [visible, setVisible] = useState<boolean>(false)
    //账单详情
    const [billCode, setBillCode] = useState<string>();
    const [billOrderVisible, setBillOrderVisible] = useState<boolean>(false);

    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])

    //列表数据
    const loadData = async (page: ISearchPage = pgCfgRef.current, searchValue: any = searchParam) => {
        setLoading(true)
        const searchParams = {
            searchItem: {
                ...searchValue,
            },
            pageSize: page?.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            orders: [{ column: 'createTime', rule: 'DESC' }],
        }
        let { retData } = await settleService.total(searchParams)
        const { list, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(list)
        setLoading(false)
    }

    //设置搜索value
    const updateSearchParam = (updateParam: any) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        setSelectedRowKeys([])
        loadData(initPgCfg, {})
    }

    //获取一条详情数据 Api
    const getOne = async (id: string) => {
        setFormInfo({});
        setUploadFileList([]);

        let { retData } = await settleService.one(id)
        const { ...formVal } = retData
        const invoiceInfo = formVal?.billInvoiceList?.[0];
        retData && setFormInfo({
            ...formVal,
            ...invoiceInfo,
            billNote: formVal.note,
            invoiceNote: invoiceInfo?.note,
        });

        if (formVal.billInvoiceList.length > 0) {
            setUploadFileList([{
                uid: formVal?.billInvoiceList?.[0]?.id,
                name: formVal?.billInvoiceList?.[0]?.invoiceFileName,
                type: "pdf",
                status: 'done',
                url: getBaseImgLookUrl(formVal?.billInvoiceList?.[0]?.invoiceMd5),
                thumbUrl: getBaseImgLookUrl(formVal?.billInvoiceList?.[0]?.invoiceMd5),
            }]);
        }
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        visible,
        mode,
        formInfo,
        loading,
        billCode,
        billOrderVisible,
        uploadFileList,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        getOne,
        setVisible,
        setMode,
        setFormInfo,
        setBillCode,
        setBillOrderVisible,
    }
})
